export class InterviewContact {
    // staff
    button;
    form;
    interviewData;

    constructor() {
        this.init();
    }

    init() {
        this.button = $('.interview__contact-button');
        this.form = $('#formContactInterview');
        this.interviewData = $('.interview__data');

        if (!this.button.length || !this.form.length || !this.interviewData.length) {
            return;
        }

        this.bindEvents();
        this.postFormContactInterview();

    }

    bindEvents() {
        this.button.on('click', (e) => {
            e.preventDefault();

            this.form.removeClass('tag--hidden');
            this.button.addClass('tag--hidden');
        });
    }

    postFormContactInterview() {
        this.form.on("submit", (e) => {
            e.preventDefault();

            let responsecaptcha = grecaptcha.getResponse();
            if(responsecaptcha.length === 0) {
                alert('No puedes dejar el código Captcha vacío.');
                return
            }

            let formIsValid = true;
            [
                'name',
                'question',
                'city',
            ].forEach((controlId) => {
                if (formIsValid && !document.getElementById(controlId).validity.valid) {
                    formIsValid = false;
                }
            });

            let intContentIdData = this.interviewData.data('intcontentid');
            let userData = $('#formContactInterview').serialize();
            userData = userData + '&intContentId=' + intContentIdData;

            if (formIsValid) {
                $.ajax({
                    url: '/tmdcontentinterview/interviewcontactform/',
                    type: 'POST',
                    data: userData,
                    success: () => {
                        alert('Pregunta enviada ¡Gracias por participar!');
                        document.getElementById('formContactInterview').reset();
                        grecaptcha.reset()

                        this.form.addClass('tag--hidden');
                        this.button.removeClass('tag--hidden');
                    },
                    error: () => {
                        alert('Ha ocurrido algun error. Vuelva a intentarlo más tarde.')
                    }
                });
            }
        });
    }
}
